import { size } from '../size/size.js';
function largerThan(theme) {
  return breakpoint => "@media (min-width: ".concat(size({
    size: breakpoint,
    sizes: theme.breakpoints
  }), "px)");
}
function smallerThan(theme) {
  return breakpoint => "@media (max-width: ".concat(size({
    size: breakpoint,
    sizes: theme.breakpoints
  }) - 1, "px)");
}
export { largerThan, smallerThan };